import { useCallback, useMemo, useState } from 'react';
import { FIT_DESCRIPTIONS, FIT_LABELS, FIT_MODES } from '../config/videoPlayer.config';

/**
 * Stores which video sizing mode is active.
 *
 * The hook cycles through the available fit modes and returns the current object-fit
 * value, the short button label, and the longer description shown by the controls.
 */
const useVideoFitMode = () => {
  const [fitMode, setFitMode] = useState('contain');

  const showNextFitMode = useCallback(() => {
    setFitMode((currentFitMode) => {
      const nextIndex = (FIT_MODES.indexOf(currentFitMode) + 1) % FIT_MODES.length; // Wrap around to the beginning of the array if at the end
      return FIT_MODES[nextIndex];
    });
  }, []);

  return useMemo(
    () => ({
      fitMode,
      fitLabel: FIT_LABELS[fitMode],
      fitDescription: FIT_DESCRIPTIONS[fitMode],
      showNextFitMode,
    }),
    [fitMode, showNextFitMode],
  );
};

export default useVideoFitMode;
